import { combineReducers } from 'redux';
import LoginReducer from './loginReducers';
import ProfileReducer from './profileReducer';
import Loader from './Loader';
import Skills from './Skills';

const appReducer = combineReducers({
    LoginReducer,
    ProfileReducer,
    Loader,
    Skills
});

// reset the state of a redux store
const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
